import { Subject } from "rxjs";

const SupervisorRefreshSubject = new Subject();

const SupervisorRefreshService = {
  listen: () => SupervisorRefreshSubject.asObservable(),
  refresh: () => SupervisorRefreshSubject.next(),
};

export default SupervisorRefreshService;
